
export const ChartDataType = {
  number: 1, // 数量
  percent: 2 // 百分比
};

// 统计报表的图形类型
export const ChartType = {
  circle: 1, // 环形图
  pie: 2, // 饼图
  bar: 3, // 柱状图
  line: 4, // 折线图
  stack: 5, // 堆叠
  strip: 6, // 条形图
  gauge: 7, // 仪表盘
  radar: 8 // 雷达图
};
